namespace RedBullMOBILE360.Web.API {
    export namespace FraudService {
        export const baseUrl = '~/api/Fraud';


        export declare const enum Methods {

        }

    }
}
